(function(){
      var root = document.currentScript.closest('.custom-clp8n3');
      if(!root) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* ---- THE FLOATING BASKET (user 2026-09-20: "when the filters sticky ... add at bottom sticky
             cart icons with count"). fabShow() is called from the toolbar's own stuck check further
             down, so the button and the glass bar always agree about whether the page is scrolled.
             Moved to <body>: a fixed element inside anything that is ever transformed is positioned
             against that ancestor, not the window. Re-renders in the theme editor reuse the one
             already there rather than stacking a second. ---- */
      var fabShow = function(){};
      (function(){
        var fab = root.querySelector('[data-fab]');
        if(!fab) return;
        var old = document.body.querySelector(':scope > [data-fab]');
        if(old && old !== fab) old.remove();
        document.body.appendChild(fab);
        var nEl = fab.querySelector('[data-fab-n]'), last = nEl ? (parseInt(nEl.textContent, 10) || 0) : 0;
        function setN(n){
          n = parseInt(n, 10) || 0;
          if(!nEl) return;
          nEl.hidden = n === 0;
          nEl.textContent = n > 99 ? '99+' : n;
          fab.setAttribute('aria-label', n ? 'Open basket, ' + n + (n === 1 ? ' item' : ' items') : 'Open basket');
          if(n !== last && n > 0){
            nEl.classList.remove('custom-clp8n3__fab-n--bump'); void nEl.offsetWidth;
            nEl.classList.add('custom-clp8n3__fab-n--bump');
          }
          last = n;
        }
        /* the basket drawer owns the truth and says so after every render; candyCartCount is the
           same number kept for a listener that arrives after the first announcement */
        document.addEventListener('candy:cart:count', function(e){ setN(e.detail && e.detail.count); });
        if(typeof window.candyCartCount === 'number') setN(window.candyCartCount);
        fab.addEventListener('click', function(){
          if(window.candyCartDrawer) window.candyCartDrawer.open('cart'); else window.location.href = '/cart';
        });
        fabShow = function(on){ fab.classList.toggle('custom-clp8n3__fab--on', !!on); };
      })();

      /* ---- toolbar glass state: --stuck once the bar's place in the page has reached
             the line it pins to (see tbCheck); at rest it's transparent ---- */
      /* ---- PERF (2026-07-20) ---- */
      /* (a) end each card's skeleton shimmer as soon as its image is painted */
      Array.prototype.forEach.call(root.querySelectorAll('.custom-clp8n3__media'), function(media){
        var im = media.querySelector('.custom-clp8n3__img');
        var done = function(){ media.classList.add('custom-clp8n3__media--ready'); };
        if(!im || im.complete){ done(); return; }
        im.addEventListener('load', done, { once: true });
        im.addEventListener('error', done, { once: true });
      });
      /* A supplied phone still replaces the desktop hero video without downloading it.
         Re-check on resize so the desktop video and its controls work after rotation. */
      var responsiveBannerVideo = root.querySelector('.custom-clp8n3__banner-vid[data-mobile-banner]');
      if(responsiveBannerVideo){
        var bannerPhone = window.matchMedia('(max-width: 768px)');
        var syncBannerVideo = function(){
          var v = responsiveBannerVideo;
          v.__mobileBannerHidden = bannerPhone.matches;
          v.pause();
          Array.prototype.forEach.call(v.querySelectorAll('source[data-src]'), function(s){
            if(bannerPhone.matches) s.removeAttribute('src');
            else s.setAttribute('src', s.getAttribute('data-src'));
          });
          if(bannerPhone.matches) v.removeAttribute('poster');
          else if(v.dataset.desktopPoster) v.setAttribute('poster', v.dataset.desktopPoster);
          v.load();
          if(!bannerPhone.matches && !v.__userPaused){ var pr = v.play(); if(pr && pr.catch) pr.catch(function(){}); }
        };
        syncBannerVideo();
        if(bannerPhone.addEventListener) bannerPhone.addEventListener('change', syncBannerVideo);
        else bannerPhone.addListener(syncBannerVideo);
      }
      /* (b) the banner + lifestyle-tile videos are autoplay/loop, so they decode
             every frame even when scrolled far past — pause them offscreen */
      if('IntersectionObserver' in window){
        var alwaysVids = root.querySelectorAll('.custom-clp8n3__banner-vid, .custom-clp8n3__tile-vid');
        if(alwaysVids.length){
          var avIO = new IntersectionObserver(function(entries){
            entries.forEach(function(e){
              var v = e.target;
              if(e.isIntersecting){ if(v.__userPaused || v.__mobileBannerHidden) return; var pr = v.play(); if(pr && pr.catch) pr.catch(function(){}); }   /* __userPaused: banner pause button (2026-09-05) */
              else v.pause();
            });
          }, { rootMargin: '160px 0px' });
          Array.prototype.forEach.call(alwaysVids, function(v){ avIO.observe(v); });
        }
      }

      var tbEl = root.querySelector('.custom-clp8n3__toolbar');
      if(tbEl){
        var ftg = root.querySelector('.custom-clp8n3__ftoggle');
        var tbTick = false;
        var wasStuck = null;
        var tbRows = function(){ return Array.prototype.slice.call(tbEl.querySelectorAll('.custom-clp8n3__filters')); };
        /* the stick/unstick boundary now ANIMATES the rows folding/growing (user
           2026-07-16 "it jumps instant"): going sticky keeps the rows rendered
           (--open) while they tween to height 0, THEN display:none applies;
           un-sticking grows them back from 0. First run (wasStuck null) is silent. */
        /* NO JUMP WHEN IT STICKS (user 2026-09-14: "when i scroll the page jerk ... due to sticky filter it
           should be smooth never jerk"). The toolbar is position:sticky, so it stays in the page flow, and
           going stuck shrinks it: the filter rows fold away and, on a decades page, the circles go compact
           (431px down to 161px on Retro at 1440). Everything under it moved up by the difference in one
           frame, and back down on the way up. Now the space it gives up is held as margin-bottom while it is
           stuck, so the page under it never moves; only the bar itself changes. --snap switches transitions
           off for the frame the new height is measured, so the number is the end state, not the tween's start. */
        /* The space is held by an empty block right after the toolbar, not by the toolbar's own
           margin-bottom: a margin there collapses into the next block's margin-top (the favourites band
           has 24px), so 24px of the jump survived. A block with a height cannot collapse. */
        var tbComp = 0;
        var tbSpace = document.createElement('div');
        tbSpace.className = 'custom-clp8n3__tbspace';
        tbSpace.setAttribute('aria-hidden', 'true');
        /* its own formatting context, so even at 0px its margins never collapse through it: tbCheck reads the
           bar's place from the spacer's top, which must sit exactly on the bar's bottom edge */
        tbSpace.style.display = 'flow-root';
        tbEl.insertAdjacentElement('afterend', tbSpace);
        /* SMOOTH, AND STILL NO JUMP (user 2026-09-14: "filters does not moving sticky smoothly its
           instants"). The change used to be committed in one frame. Now it morphs over .35s: the circles
           shrink, the paddings ease, and the filter rows fade while their wraps fold, each wrap's height
           pinned in px so it can tween (auto cannot). --morph keeps the rows drawn while they fade, and on
           every frame of the tween the spacer is set to the room the bar has given up, so the page under it
           holds still the whole time. --snap is only for the one frame the end state is measured.
           Reduced motion, a reload that lands mid-page and a resize go straight to the end state. */
        /* ONE CLOCK: the bar's own height and the spacer's height are both pinned in px and tween together
           (same .35s, same ease, started in the same frame), one from h0 to h1 and the other from s0 to
           s1 = s0 + h0 - h1, so their sum, the room they take in the page, is the same on every frame and
           nothing under them moves. A per-frame follower in rAF was one frame behind the tween and let the
           page drift up to 60px; this has nothing to lag. The rows and circles inside tween on the same
           clock too, and the bar clips them (overflow hidden) only for the .35s it is moving. */
        var mTimer = 0, mWraps = null, mFlow = 0, mOn = false;
        /* always a px value, 0px included: height can only tween between two lengths, and "auto" at
           either end made the spacer jump its whole height in one frame while the bar was still moving */
        var setSpace = function(px){
          tbComp = Math.max(0, Math.round(px));
          tbSpace.style.height = (tbComp / window.innerWidth * 100) + 'vw';
        };
        var mFinish = function(){
          if(!mOn) return;
          mOn = false;
          clearTimeout(mTimer);
          tbEl.classList.add('custom-clp8n3__toolbar--snap');
          tbEl.style.height = ''; tbEl.style.overflow = ''; tbEl.style.boxSizing = '';
          mWraps.forEach(function(w){ w.style.height = ''; w.style.overflow = ''; w.style.boxSizing = ''; });
          mWraps = null;
          tbEl.classList.remove('custom-clp8n3__toolbar--morph');
          tbSpace.classList.remove('custom-clp8n3__tbspace--morph');
          setSpace(mFlow - tbEl.offsetHeight);
          requestAnimationFrame(function(){ tbEl.classList.remove('custom-clp8n3__toolbar--snap'); });
        };
        var tbMorph = function(apply0, animate){
          /* THE CIRCLE ROW HOLDS ITS PLACE THROUGH THE MORPH (user 2026-09-20: "after scrolled its
             change position why? check from center to left", "when i scroll the center was comes from
             left or right suddenly").

             The circles are a different size once the bar sticks, and that size change is instant --
             nothing tweens a width here. So the moment the class flips, the same scrollLeft points at a
             different circle and the row jumps sideways; and when the content gets shorter than the
             current position the browser clamps scrollLeft on top of that, which does not undo itself.
             apply() is called THREE times per transition -- once to measure the end state, once to go
             back to the start, once for real -- so the row was being shoved about three times and only
             put right afterwards, which is the sideways slide that was visible.

             Every one of those toggles is wrapped now: note which circle is in the middle, flip the
             class, put that circle back in the middle. It happens inside one frame, before anything is
             painted, so there is nothing to see -- no animation to smooth, because there is no longer a
             movement to smooth out. */
          var apply = function(v){
            if(window.c4uCirclesHold) window.c4uCirclesHold();
            apply0(v);
            if(window.c4uCirclesRemeasure) window.c4uCirclesRemeasure();
          };
          mFinish();
          var h0 = tbEl.offsetHeight;
          var flow = h0 + tbComp;                   /* the room it takes in the page: held constant */
          tbEl.classList.add('custom-clp8n3__toolbar--snap');
          if(!animate || reduce){
            apply(true);
            setSpace(flow - tbEl.offsetHeight);
            requestAnimationFrame(function(){ tbEl.classList.remove('custom-clp8n3__toolbar--snap'); });
            return;
          }
          var wraps = Array.prototype.slice.call(tbEl.querySelectorAll('.custom-clp8n3__filters-wrap'));
          var from = wraps.map(function(w){ return w.offsetHeight; });
          apply(true);                              /* measure the end state */
          var h1 = tbEl.offsetHeight;
          var to = wraps.map(function(w){ return w.offsetHeight; });
          apply(false);
          /* pin the start in px, transitions still off */
          tbEl.classList.add('custom-clp8n3__toolbar--morph');
          tbSpace.classList.add('custom-clp8n3__tbspace--morph');
          tbEl.style.boxSizing = 'border-box'; tbEl.style.overflow = 'hidden'; tbEl.style.height = (h0 / window.innerWidth * 100) + 'vw';
          wraps.forEach(function(w, i){ w.style.boxSizing = 'border-box'; w.style.overflow = 'hidden'; w.style.height = (from[i] / window.innerWidth * 100) + 'vw'; });
          setSpace(flow - h0);
          void tbEl.offsetHeight;
          /* go */
          tbEl.classList.remove('custom-clp8n3__toolbar--snap');
          apply(true);
          tbEl.style.height = (h1 / window.innerWidth * 100) + 'vw';
          wraps.forEach(function(w, i){ w.style.height = (to[i] / window.innerWidth * 100) + 'vw'; });
          setSpace(flow - h1);
          mWraps = wraps; mFlow = flow; mOn = true;
          mTimer = setTimeout(mFinish, 400);
        };
        /* STUCK IS READ FROM THE PAGE, NOT FROM THE BAR (client's iPhone video 2026-10-06, on every collection:
           scrolling back up, the bar dropped to its resting look while it was still pinned over the sweets -- no
           sheet, the filter rows open, "210 sweets", the cards showing through -- and flicked between the two
           looks until the page stopped moving). This used to ask the bar itself: its rect top against its css top.
           On an iPhone a sticky element's rect is worked out against where the viewport was a moment ago while the
           page is moving, so on the way up it read lower than its top and the bar was let go deep in the grid,
           over and over. The answer now comes from the spacer under it, which is ordinary flow and never misread:
           spacer top minus the bar's height is where the bar would sit if it were not sticky, and the bar is stuck
           once that spot reaches the line it pins to (its css top). Once stuck it lets go only when that spot is
           TB_LET_GO px clear of the line, so a thumb resting near the top of the grid cannot flick it either. */
        /* FAST SCROLL GETS THE STUCK LOOK AT ONCE (user 2026-10-06: "when i try to scroll to bottom fast the sticky
           showing the transparent bg instead of instant bg and sticky and sizing css applied"). The browser pins a
           sticky bar on its own, every frame, but this check only runs when the page's script gets a frame, and on a
           fast scroll that can be 100ms and more apart (measured: gaps up to 118ms at 8000px/s on Retro). The bar
           was pinned for those frames still in its resting look: no sheet, rows open, the sweets showing through.
           So the scroll speed is kept (tbVel, px per ms, + is down), and on the way down the bar sticks as soon as it
           is within 150ms of travel from the line instead of on it. Fast (1.5px/ms and up), or found already past
           the line, it goes straight to the stuck look with no tween; an ordinary scroll keeps the .35s morph.
           And the resting look can no longer be pinned at all: the bar is position:relative until it is stuck and
           only the stuck bar is sticky (candy-collection.css). If the script is late anyway, the resting bar simply
           scrolls on with the page, and drops in already dark and compact when the check catches up; it is never
           the see-through bar lying over the sweets. */
        /* ONE STEADY RULE, NOTHING READ PER FRAME (Arsalan 2026-10-08: "its sticky then unsticky due to some calcualtion
           etc please make that stickness so much best and dynamic"). Measured on live, Best Sellers 1440, this machine's
           GPU (.theme-workspace/rail-onescript-20261008, sticky_log.py):
           - flip-flop in place: with the bar just past the line and the header sliding back in, it went stuck, unstuck,
             stuck, unstuck at one scroll position. The stuck side compared against the bar's own css top (still 0px,
             sliding to 97px) and the unstuck side against the header's offset (97px), so each undid the other;
           - a quick scroll that stopped just short of the grid stuck early (the speed lead), then let go 400ms later with
             the page standing still, then stuck again on the next scroll;
           - the speed came from scroll events and read 0 once they were 250ms apart, which a busy page does, so the lead
             vanished exactly when it was needed and the bar scrolled off before it stuck;
           - each check read the bar's style and the spacer's box, forcing a whole-page style and layout on every scroll
             frame: 17ms a call, the costliest script on the page while it scrolls.
           Now both sides measure against the header's offset (--c4u-hdr-off, the same line the stuck bar's css top is
           heading to); once stuck it lets go only on the way UP, when its place is TB_LET_GO clear of that line, never
           because time passed or the header moved; the speed and direction come from this check's own samples; and the
           bar's place in the page (tbFlow) is measured only when the page's layout changes (ResizeObserver), so a scroll
           frame reads scrollY and nothing else. The spacer stays the reference (the iPhone fix above), and the first
           look on a page opened half way down is simply "is it past the line". */
        var TB_LET_GO = 24;
        var tbDoc = document.documentElement;
        var tbFlow = null, tbLastY = null, tbLastT = 0, tbLastDy = 0, tbVel = 0, tbDir = 0, tbGap = 150, tbRun = false, tbHdrH = 0;
        var tbMeasure = function(){
          tbFlow = tbSpace.getBoundingClientRect().top + window.pageYOffset - tbEl.offsetHeight - (parseFloat(getComputedStyle(tbEl).marginBottom) || 0);
        };
        var tbCheck = function(){
          tbTick = false;
          var now = performance.now(), y = window.pageYOffset;
          if(tbFlow === null) tbMeasure();
          var dt = now - tbLastT;
          if(tbLastY === null || dt >= 4){       /* two checks in one frame are one sample */
            var dy = tbLastY === null ? 0 : y - tbLastY;
            tbVel = dt > 0 && dt < 1000 ? dy / dt : 0;
            if(dy > 0) tbDir = 1; else if(dy < 0) tbDir = -1;
            /* a scroll in progress: this check and the last both moved, the same way. A jump from a standstill (a link,
               a script) is not a speed to lead by. */
            tbRun = dy !== 0 && tbLastDy !== 0 && (dy > 0) === (tbLastDy > 0) && dt < 1000;
            if(dy && dt > 0) tbGap = Math.max(16, Math.min(150, dt * 1.5));
            tbLastY = y; tbLastT = now; tbLastDy = dy;
          }
          var v = tbVel;
          var line = (function(v){return (parseFloat(v)||0) * (/vw\s*$/.test(v) ? window.innerWidth / 100 : 1);})(tbDoc.style.getPropertyValue('--c4u-hdr-off'));
          if(line > 0) tbHdrH = line;          /* the header's height when it shows */
          var spot = tbFlow - y;
          /* the lead is the travel until the next check: 150ms of it on a busy page as before, about a frame and a half
             when frames come every 16ms, so a scroll that stops just short of the grid no longer leaves the bar folded
             a long way under the line */
          var lead = tbRun && v > 0.5 ? Math.min(1600, v * tbGap) : 0;
          var stuck = wasStuck === null ? spot <= line + 1
            /* on the way up the header comes back after 6px (candy-header.liquid), so it lets go against the line the
               header WILL be at: measured against "away" for that one frame it let go, then stuck again under the header */
            : wasStuck ? !(tbDir < 0 && spot > Math.max(line, tbHdrH) + TB_LET_GO)
            : spot <= line + 1 + lead;
          if(stuck === wasStuck) return;
          var late = stuck ? spot < line - 30 : spot > line + 150;
          fabShow(stuck);                    /* the floating basket keeps the bar's hours */
          /* the circle row holds its place through this: tbMorph pins it around each flip of the class,
             and the pin below holds it for the length of the bar's own padding tween */
          if(window.c4uCirclesPin) window.c4uCirclesPin(480);
          var first = wasStuck === null;
          var wasOpen = tbEl.classList.contains('custom-clp8n3__toolbar--open');
          wasStuck = stuck;
          if(ftg) ftg.setAttribute('aria-expanded', 'false');
          tbMorph(function(on){
            tbEl.classList.toggle('custom-clp8n3__toolbar--stuck', on ? stuck : !stuck);
            tbEl.classList.toggle('custom-clp8n3__toolbar--open', on ? false : wasOpen);
          }, !first && !late && Math.abs(v) < 1.5);
        };
        window.addEventListener('scroll', function(){
          if(!tbTick){ tbTick = true; requestAnimationFrame(tbCheck); }
        }, { passive: true });
        tbCheck();
        /* the bar's place in the page moves only when the layout does (fonts, a picture without a size above it, Load
           more below, a width change): measured again then, inside the observer, where the layout is already worked
           out and the read costs nothing; and checked straight away if it moved. */
        if('ResizeObserver' in window) new ResizeObserver(function(){
          var was = tbFlow;
          tbMeasure();
          if(was !== null && Math.abs(tbFlow - was) > 1) tbCheck();
        }).observe(document.body);
        /* STUCK STATE NEVER MISSED (2026-09-27: "sometimes the bg colors does not load of the sticky"). The check above
           only ran on scroll, but the bar's own `top` animates for .45s whenever the header slides away or back
           (--c4u-hdr-off), and a page opened or reloaded half way down lays out after the first check. If scrolling
           stopped inside either of those windows the bar was left pinned but still marked not-stuck: no background,
           filter rows open, sweets showing through. It is now checked again when that animation ends, when the
           header offset changes, when the page has loaded, and once scrolling has settled. */
        tbEl.addEventListener('transitionend', function(e){ if(e.target === tbEl && e.propertyName === 'top') tbCheck(); });
        if('MutationObserver' in window) new MutationObserver(function(){ requestAnimationFrame(tbCheck); }).observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
        window.addEventListener('load', function(){ requestAnimationFrame(tbCheck); });
        window.addEventListener('pageshow', function(){ requestAnimationFrame(tbCheck); });
        var tbIdle = 0;
        window.addEventListener('scroll', function(){
          clearTimeout(tbIdle); tbIdle = setTimeout(tbCheck, 180);
        }, { passive: true });
        /* Filters while stuck opens and closes the rows with the same morph and the same held space,
           so the grid behind does not move either. */
        if(ftg) ftg.addEventListener('click', function(){
          var opening = !tbEl.classList.contains('custom-clp8n3__toolbar--open');
          ftg.setAttribute('aria-expanded', opening ? 'true' : 'false');
          tbMorph(function(on){ tbEl.classList.toggle('custom-clp8n3__toolbar--open', on ? opening : !opening); }, true);
        });
        /* the space it holds depends on the width, so a resize while stuck measures it again. Width only: on a
           phone the address bar sliding in and out fires resize with just the height changed, and re-measuring
           then cut a running morph short and shut an open Filters panel in the middle of a scroll (2026-10-06). */
        var tbRz = 0, tbW = window.innerWidth;
        window.addEventListener('resize', function(){
          if(window.innerWidth === tbW) return;
          tbW = window.innerWidth;
          clearTimeout(tbRz);
          tbRz = setTimeout(function(){
            if(!wasStuck) return;
            mFinish();
            tbEl.classList.add('custom-clp8n3__toolbar--snap');
            setSpace(0);
            tbEl.classList.remove('custom-clp8n3__toolbar--stuck', 'custom-clp8n3__toolbar--open');
            if(ftg) ftg.setAttribute('aria-expanded', 'false');
            var natural = tbEl.offsetHeight;
            tbEl.classList.add('custom-clp8n3__toolbar--stuck');
            setSpace(natural - tbEl.offsetHeight);
            requestAnimationFrame(function(){ tbEl.classList.remove('custom-clp8n3__toolbar--snap'); });
          }, 150);
        }, { passive: true });
      }

      /* ---- THE CIRCLES STRIP (drag with glide, the loop, centring on the current collection, edge fades and the
             window.c4uCircles* hooks the toolbar above calls) runs inline in sections/candy-collection.liquid, right
             after the row, since 2026-10-08 (Arsalan: "on refresh first its not showing the collection circles then
             ... not correct design ... make it one"). Here, deferred, it only ran once the whole page had arrived, so
             the row was hidden, then shown unready by the CSS timer, then moved. Same code, one place, run once. ---- */

      /* ---- TASTE SORT (client 2026-09: "Sort by sourest, fizziest and sweetest using the
             taste data we already have") ----
         Liquid cannot sort a collection by a metafield and the taste metafields have no
         Storefront access, so there is no server-side sort to navigate to. These three
         options reorder the cards that are already in the DOM instead.

         The section only renders them when the whole collection fits on one page, so this
         never claims to have sorted products it cannot see.

         The promo tiles are pulled out while a taste sort is on. They are placed "after the
         Nth product" by Liquid, and once the order changes that position means nothing — an
         "after 8" banner would end up interrupting an arbitrary pair of cards.

         The choice is written to ?taste= so a reload and a shared link both keep it, which is
         what the shopper expects from something that looks like the sort control. */
      var grid = root.querySelector('.custom-clp8n3__grid');
      var tasteOrder = null;
      function applyTaste(key){
        if(!grid) return;
        var cards = Array.prototype.slice.call(grid.querySelectorAll('.custom-clp8n3__card'));
        if(!cards.length) return;
        if(!tasteOrder) tasteOrder = cards.slice();          /* remember Shopify's order once */
        var tiles = Array.prototype.slice.call(grid.querySelectorAll('.custom-clp8n3__tile[data-tile]'));
        if(!key){
          tasteOrder.forEach(function(c){ grid.appendChild(c); });
          tiles.forEach(function(t){ t.classList.remove('custom-clp8n3__card--hide'); });
          return;
        }
        var attr = 'data-' + key;
        cards.slice().sort(function(a, b){
          var d = (parseInt(b.getAttribute(attr), 10) || 0) - (parseInt(a.getAttribute(attr), 10) || 0);
          /* stable tie-break on the original position, so equal scores keep Shopify's order
             instead of shuffling on every re-sort */
          return d || (tasteOrder.indexOf(a) - tasteOrder.indexOf(b));
        }).forEach(function(c){ grid.appendChild(c); });
        tiles.forEach(function(t){ t.classList.add('custom-clp8n3__card--hide'); });
      }
      function markTaste(key){
        var sel = root.querySelector('.custom-clp8n3__sort-sel');
        if(sel && key) sel.value = 'taste:' + key;
        Array.prototype.forEach.call(root.querySelectorAll('.custom-clp8n3__sortdd-opt'), function(o){
          var on = o.getAttribute('data-val') === 'taste:' + key;
          o.setAttribute('aria-selected', on ? 'true' : 'false');
          o.classList.toggle('custom-clp8n3__sortdd-opt--on', on);
        });
      }
      (function initTaste(){
        var k = new URL(window.location.href).searchParams.get('taste');
        if(k === 'sweet' || k === 'sour' || k === 'fizzy'){ applyTaste(k); markTaste(k); }
      })();

      /* ---- sort: navigate with sort_by, dropping any page param ---- */
      var sortSel = root.querySelector('.custom-clp8n3__sort-sel');
      function navSort(v){
        var u = new URL(window.location.href);
        if(v && v.indexOf('taste:') === 0){
          var key = v.slice(6);
          u.searchParams.set('taste', key);
          u.searchParams.delete('page');
          history.replaceState({}, '', u.toString());
          applyTaste(key);
          markTaste(key);
          return;                                            /* no reload — it is all client side */
        }
        u.searchParams.set('sort_by', v);
        u.searchParams.delete('taste');
        u.searchParams.delete('page');
        window.location.href = u.toString();
      }
      /* THE SORT CAPSULE FITS WHAT IT SAYS (user 2026-09-20: "align").

         A select is as wide as its LONGEST option, not the one showing. "Alphabetically, A-Z" is 149px
         and "Best selling" is 89px, so the capsule carried 60px of empty space between the words and
         the chevron, and the chevron looked stranded. Nothing was mis-centred: the padding either side
         measured 22px and every part sat on the same middle line. It was the hole.

         So the select is measured against the option actually selected and given that width. Canvas
         measureText rather than a hidden clone: no element to insert and no second layout. It runs
         again once the webfont has landed, because the first measurement is done in the fallback face,
         and on a resize, because the type is sized in vw. A sort change usually reloads the page, but
         the taste sorts do not, so it runs there too. */
      var sortCv = null;
      function fitSort(){
        if(!sortSel) return;
        var o = sortSel.options[sortSel.selectedIndex];
        if(!o) return;
        var cs = getComputedStyle(sortSel);
        if(!sortCv){
          var cv = document.createElement('canvas');
          sortCv = cv.getContext ? cv.getContext('2d') : null;
          if(!sortCv) return;
        }
        sortCv.font = cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
        var w = Math.ceil(sortCv.measureText(o.text).width) + parseFloat(cs.paddingRight || 0) + 2;
        sortSel.style.width = (w / window.innerWidth * 100) + 'vw';
      }
      if(sortSel){
        sortSel.addEventListener('change', function(){ fitSort(); navSort(sortSel.value); });
        fitSort();
        if(document.fonts && document.fonts.ready) document.fonts.ready.then(fitSort);
        var sortRz = 0;
        window.addEventListener('resize', function(){
          clearTimeout(sortRz);
          sortRz = setTimeout(fitSort, 150);
        }, { passive: true });
      }
      /* custom dropdown (desktop) — options cascade in one-by-one */
      var sortWrap = root.querySelector('.custom-clp8n3__sort');
      var sortDD = root.querySelector('.custom-clp8n3__sortdd');
      if(sortWrap && sortDD){
        var ddOpen = false;
        var setDD = function(o){
          ddOpen = o;
          sortWrap.classList.toggle('custom-clp8n3__sort--dd', o);
        };
        sortWrap.addEventListener('click', function(e){
          var opt = e.target.closest ? e.target.closest('.custom-clp8n3__sortdd-opt') : null;
          if(opt){ navSort(opt.getAttribute('data-val')); return; }
          e.preventDefault();
          setDD(!ddOpen);
        });
        document.addEventListener('click', function(e){ if(ddOpen && !sortWrap.contains(e.target)) setDD(false); });
        document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && ddOpen) setDD(false); });
      }

      /* ---- FILTER GROUPS (client 2026-07-10): dietary + texture + sour level.
             Instant client-side by each card's data-diet / data-tex / data-sour.
             OR within a group, AND across groups. "All" clears its group; the
             "Clear filters" pill (next to the count) resets everything in one
             tap. Zero matches -> the Build-Your-Own dead-end panel, never a
             blank page. ---- */
      /* NO FILTERS, NO FILTERS BUTTON (user 2026-09-20: "when there is no filters why showing the
         filter icon"). Two different collections end up with nothing to filter by. Marshmallow is
         twelve sweets and not one of them carries a dietary, texture or crunch tag, so Liquid prints no
         groups at all; elsewhere the groups are printed and the pruning inside the block below empties
         every one of them. Either way the sticky bar was still offering a Filters button that opened
         onto nothing. If no group is left, the button goes, and so does the row that would have held
         the groups along with the space it was taking.

         It lives OUT here and is called AFTER that block, not inside it: the block's first act is to
         give up when a collection has no chip groups, which is the very case this is for. */
      function hideEmptyFilterUI(){
        var boxes = Array.prototype.slice.call(root.querySelectorAll('.custom-clp8n3__filters'));
        for(var i = 0; i < boxes.length; i++){ if(!boxes[i].hidden) return; }
        var ftgB = root.querySelector('.custom-clp8n3__ftoggle');
        if(ftgB) ftgB.hidden = true;
        Array.prototype.forEach.call(root.querySelectorAll('.custom-clp8n3__filters-wrap'), function(w){ w.hidden = true; });
      }
      (function(){
        var groups = Array.prototype.slice.call(root.querySelectorAll('.custom-clp8n3__chips[data-group]'));
        if(!groups.length) return;
        var attrOf = { diet: 'data-diet', tex: 'data-tex', era: 'data-era', sour: 'data-sour', crunch: 'data-crunch' };
        var cardEls = Array.prototype.slice.call(root.querySelectorAll('.custom-clp8n3__card'));
        /* THE PROMO TILES ARE PART OF THE GRID TOO (client 2026-09). The filter only ever
           walked the cards, so filtering forty products down to three left the "after 8"
           Build Your Own banner stranded in a three-card grid, interrupting nothing. They
           are hidden whenever any filter is on and restored when the filters clear — the
           same --hide class the cards use, so one rule covers both. */
        var tileEls = Array.prototype.slice.call(root.querySelectorAll('.custom-clp8n3__tile[data-tile]'));
        /* The Favourites band is the CATEGORY's hand-picked row, not a filter result, and it sits
           between the toolbar and the grid. See the note in apply(). */
        var favBand = root.querySelector('.custom-fav7q');
        var countNum = root.querySelector('.custom-clp8n3__count-num');
        var collectionCount = countNum ? countNum.getAttribute('data-count') : null;
        var clearAll = root.querySelector('.custom-clp8n3__clearall');
        var noRes = root.querySelector('.custom-clp8n3__noresults');
        var grid = root.querySelector('.custom-clp8n3__grid');
        var active = { diet: [], tex: [], era: [], sour: [], crunch: [] };
        /* DECADE CIRCLES (client 2026-09-14, Retro). The circles in the sticky toolbar are the Era filter
           wearing photos: one decade at a time, a tap on the lit one clears it, and the Era chips below stay
           multi-select. Both paint from active.era. "When one is selected change the page heading to match,
           so choosing 80s gives you Retro, the 80s": the decade words go in a span that keeps its own case,
           so the uppercase heading reads RETRO, THE 80s rather than THE 80S. */
        var decBtns = Array.prototype.slice.call(root.querySelectorAll('.custom-clp8n3__decade'));
        var titleEl = decBtns.length ? root.querySelector('.custom-clp8n3__title') : null;
        var titleBase = titleEl ? titleEl.textContent : '';
        var eraChipEls = Array.prototype.slice.call(root.querySelectorAll('.custom-clp8n3__chips[data-group="era"] .custom-clp8n3__chip:not(.custom-clp8n3__chip--clear)'));
        function paintTitle(){
          if(!titleEl) return;
          var seen = false;
          var names = eraChipEls.filter(function(ch){ return active.era.indexOf(ch.getAttribute('data-val')) > -1; })
            .map(function(ch){
              var w = ch.textContent.trim();
              if(/^\d/.test(w)){ var o = (seen ? '' : 'THE ') + w; seen = true; return o; }
              return w.toUpperCase();
            });
          var txt = names.length < 2 ? (names[0] || '') : names.slice(0, -1).join(', ') + ' AND ' + names[names.length - 1];
          if(titleEl.__era === txt) return;
          titleEl.__era = txt;
          titleEl.textContent = titleBase;
          if(txt){
            var sp = document.createElement('span');
            sp.className = 'custom-clp8n3__title-era';
            sp.textContent = ', ' + txt;
            titleEl.appendChild(sp);
          }
        }
        /* stuck over the grid, a tap brings the top of the grid back under the toolbar, so the answer is on
           screen instead of wherever the scroll had got to */
        function toGrid(){
          var tb = root.querySelector('.custom-clp8n3__toolbar');
          if(!tb || !tb.classList.contains('custom-clp8n3__toolbar--stuck')) return;
          var tgt = (grid && grid.style.display !== 'none') ? grid : noRes;
          if(!tgt) return;
          var y = tgt.getBoundingClientRect().top + window.pageYOffset - tb.offsetHeight - (parseFloat(getComputedStyle(tb).top) || 0) - 12;
          if(window.pageYOffset > y) window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
        }
        function anyActive(){ return active.diet.length + active.tex.length + active.era.length + active.sour.length + active.crunch.length > 0; }
        function apply(){
          /* re-read every time: Load More appends cards after init (client 2026-09-04) */
          cardEls = Array.prototype.slice.call(root.querySelectorAll('.custom-clp8n3__card'));
          var filtering = anyActive();
          var shown = 0;
          cardEls.forEach(function(c){
            if(c.hasAttribute('data-favourite')) c.hidden = !filtering;
            var ok = true;
            groups.forEach(function(g){
              var key = g.getAttribute('data-group');
              var act = active[key];
              if(!act || !act.length) return;
              var hit;
              if(g.getAttribute('data-mode') === 'min'){
                /* threshold groups (sour/crunch): chip N means "score N and up" */
                var v = parseInt(c.getAttribute(attrOf[key]), 10) || 0;
                hit = act.some(function(t){ return v >= (parseInt(t, 10) || 0); });
              } else {
                var d = ' ' + (c.getAttribute(attrOf[key]) || '') + ' ';
                hit = act.some(function(t){ return d.indexOf(' ' + t + ' ') > -1; });
              }
              if(!hit) ok = false;
            });
            c.classList.toggle('custom-clp8n3__card--hide', !ok);
            if(ok && !c.hidden){
              shown++;
            }
          });
          tileEls.forEach(function(t){ t.classList.toggle('custom-clp8n3__card--hide', filtering); });
          /* HIDE THE FAVOURITES BAND WHILE FILTERING (client 2026-09-21: "when you filter by halal,
             gluten free, vegan & vegetarian, it doesn't filter properly, it still shows the category
             you have chosen above in the small circles").

             The chips always did filter the grid correctly - Halal on Gummy really does leave five
             cards and the counter really does say 5. What the client was looking at was the band
             ABOVE the grid: Gummy Favourites, eight products the client picked for the category,
             none of them halal, still sitting under the toolbar. So the page read as "still showing
             the category" no matter what the counter said. The promo tiles on the line above were
             already hidden for exactly this reason; the band was missed.

             It is a category showcase, not a result, so it goes while any chip is on and comes
             straight back on Clear. */
          if(favBand) favBand.style.display = filtering ? 'none' : '';
          if(countNum){
            var count = filtering ? shown : collectionCount;
            countNum.textContent = count;
            countNum.setAttribute('data-count', count);
          }
          if(clearAll) clearAll.hidden = !anyActive();
          var ftgN = root.querySelector('.custom-clp8n3__ftoggle-n');
          if(ftgN){
            var nAct = active.diet.length + active.tex.length + active.era.length + active.sour.length + active.crunch.length;
            ftgN.textContent = nAct;
            ftgN.hidden = nAct === 0;
          }
          if(noRes){
            noRes.hidden = !filtering || shown !== 0;
          }
          if(grid) grid.style.display = shown === 0 ? 'none' : '';
          paintChips();
        }
        /* the chips, the "Clear filters" pill and the count bubble on the Filters button. Split
           out of apply() so a chip can light up straight away while the rest of the collection is
           still on its way (user 2026-09-12). */
        function paintChips(){
          if(clearAll) clearAll.hidden = !anyActive();
          var ftgN = root.querySelector('.custom-clp8n3__ftoggle-n');
          if(ftgN){
            var nAct = active.diet.length + active.tex.length + active.era.length + active.sour.length + active.crunch.length;
            ftgN.textContent = nAct;
            ftgN.hidden = nAct === 0;
          }
          groups.forEach(function(g){
            var key = g.getAttribute('data-group');
            Array.prototype.forEach.call(g.querySelectorAll('.custom-clp8n3__chip'), function(ch){
              var t = ch.getAttribute('data-val');
              var on = t === '' ? active[key].length === 0 : active[key].indexOf(t) > -1;
              ch.setAttribute('aria-pressed', on ? 'true' : 'false');
            });
          });
          decBtns.forEach(function(b){
            b.setAttribute('aria-pressed', active.era.indexOf(b.getAttribute('data-val')) > -1 ? 'true' : 'false');
          });
          paintTitle();
        }
        function setLoading(on){ root.classList.toggle('custom-clp8n3--loading', !!on); }
        /* EMPTY TAG LIST (2026-09-13): when Shopify hands the section no collection tags it draws
           every chip and marks the wrap data-tags-unknown. On a collection that fits on one page
           the cards are the whole collection, so a chip no card matches is hidden, and a group left
           with only "All" goes too. Across several pages the chips stay: a miss shows the
           no-results panel rather than a chip that silently disappears. */
        (function pruneChips(){
          var wrap = root.querySelector('.custom-clp8n3__filters-wrap[data-tags-unknown]');
          /* the server pager, not morePages(): the pager script that defines c4uLoadAllPages runs after this */
          if(!wrap || root.querySelector('.custom-clp8n3__pag a[href*="page="]')) return;
          var cards = Array.prototype.slice.call(root.querySelectorAll('.custom-clp8n3__card'));
          groups.forEach(function(g){
            var key = g.getAttribute('data-group');
            if(g.getAttribute('data-mode') === 'min' || !attrOf[key]) return;
            var left = 0;
            Array.prototype.forEach.call(g.querySelectorAll('.custom-clp8n3__chip'), function(ch){
              var t = ch.getAttribute('data-val');
              if(t === '') return;
              var hit = cards.some(function(c){ return (' ' + (c.getAttribute(attrOf[key]) || '') + ' ').indexOf(' ' + t + ' ') > -1; });
              ch.hidden = !hit;
              if(hit) left++;
            });
            if(!left){ var box = g.closest('.custom-clp8n3__filters'); if(box) box.hidden = true; }
          });
        })();
        /* the chips only ever filtered the cards already in the browser, which on a
           collection spanning server pages is the first page alone (client 2026-09-11:
           "There's only three sugar-free"). The pager exposes c4uLoadAllPages: the first
           chip that goes on pulls the rest of the collection in and re-filters as each
           page lands. Collections that fit on one page never call it. */
        function morePages(){
          return typeof root.c4uLoadAllPages === 'function' &&
                 (typeof root.c4uMorePages !== 'function' || root.c4uMorePages());
        }
        /* while the rest of the collection is fetched the grid is NOT filtered on the page 1 cards:
           that is what showed "3 sweets" before correcting itself to 12. The chips light up, the
           count becomes a spinner and the cards pulse (CSS .custom-clp8n3--loading), then the real
           answer is painted in one go. */
        function loadEveryPage(){
          setLoading(true);
          root.c4uLoadAllPages(function(){ apply(); setLoading(false); });
        }
        groups.forEach(function(g){
          var key = g.getAttribute('data-group');
          g.addEventListener('click', function(e){
            var ch = e.target.closest ? e.target.closest('.custom-clp8n3__chip') : null;
            if(!ch) return;
            var t = ch.getAttribute('data-val');
            if(t === ''){ active[key] = []; }
            else {
              var i = active[key].indexOf(t);
              if(i > -1) active[key].splice(i, 1); else active[key].push(t);
            }
            if(anyActive() && morePages()){ paintChips(); loadEveryPage(); }
            else apply();
          });
        });
        decBtns.forEach(function(b){
          b.addEventListener('click', function(){
            var t = b.getAttribute('data-val');
            active.era = (active.era.length === 1 && active.era[0] === t) ? [] : [t];
            if(anyActive() && morePages()){ paintChips(); loadEveryPage(); }
            else apply();
            toGrid();
          });
        });
        if(clearAll) clearAll.addEventListener('click', function(){
          active = { diet: [], tex: [], era: [], sour: [], crunch: [] };
          apply();
        });
      })();
      hideEmptyFilterUI();

      /* ---- FILTER DROPDOWNS (client 2026-10-08, Gifts: "tidy up the filters ... We need a neater way to do it").
             With the section's Filter style on Dropdowns each group is one pill (.custom-clp8n3__dd-btn) and its
             chips sit in a panel under it. A pill opens its panel and shuts any other; a tap outside or Esc shuts
             it. The chips are untouched, so the filter block above does the filtering as before; the pill only
             writes what is picked next to its name, read from the chips' own aria-pressed, which is how it also
             picks up the server-side gift chips and "Clear filters". ---- */
      (function(){
        var boxes = Array.prototype.slice.call(root.querySelectorAll('.custom-clp8n3__filters-wrap--dd .custom-clp8n3__filters'));
        if(!boxes.length) return;
        var openBox = null;
        function setOpen(box){
          openBox = box;
          boxes.forEach(function(b){
            var on = b === box;
            b.classList.toggle('custom-clp8n3__filters--dd-open', on);
            var btn = b.querySelector('.custom-clp8n3__dd-btn');
            if(btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
          });
        }
        function paintPills(){
          boxes.forEach(function(b){
            var names = Array.prototype.map.call(b.querySelectorAll('.custom-clp8n3__chip[aria-pressed="true"]:not(.custom-clp8n3__chip--clear)'), function(ch){ return ch.textContent.trim(); });
            var val = b.querySelector('[data-dd-val]');
            if(val) val.textContent = names.length > 2 ? names.length + ' picked' : names.join(', ');
            b.classList.toggle('custom-clp8n3__filters--dd-on', names.length > 0);
          });
        }
        boxes.forEach(function(b){
          var btn = b.querySelector('.custom-clp8n3__dd-btn');
          if(btn) btn.addEventListener('click', function(){ setOpen(openBox === b ? null : b); });
        });
        document.addEventListener('click', function(e){ if(openBox && !openBox.contains(e.target)) setOpen(null); });
        document.addEventListener('keydown', function(e){
          if(e.key !== 'Escape' || !openBox) return;
          var btn = openBox.querySelector('.custom-clp8n3__dd-btn');
          setOpen(null);
          if(btn) btn.focus();
        });
        if('MutationObserver' in window){
          var mo = new MutationObserver(paintPills);
          boxes.forEach(function(b){ mo.observe(b, { attributes: true, attributeFilter: ['aria-pressed'], subtree: true }); });
          /* on a phone the stuck bar folds the pills away; a panel left open would come back open with them. On desktop
             the stuck bar keeps the pills (candy-collection.css, ONE LOOK), so an open panel stays open there. */
          var tbDD = root.querySelector('.custom-clp8n3__toolbar');
          var ddWide = window.matchMedia ? window.matchMedia('(min-width: 769px)') : null;
          if(tbDD) new MutationObserver(function(){
            if(openBox && !(ddWide && ddWide.matches) && tbDD.classList.contains('custom-clp8n3__toolbar--stuck') && !tbDD.classList.contains('custom-clp8n3__toolbar--open')) setOpen(null);
          }).observe(tbDD, { attributes: true, attributeFilter: ['class'] });
        }
        paintPills();
      })();

      /* ---- QUICK-BUY DRAWER (client 2026-07-10): + opens a bottom sheet with a
             size (variant) + quantity pick — basket builds straight from the grid.
             Product data comes from /products/<handle>.js on demand; if that
             fetch fails the button falls back to the old one-tap direct add. ---- */
      var moneyFormat = root.getAttribute('data-money-format') || '\u00a3{{amount}}';
      function money(cents){
        var v = (cents / 100).toFixed(2);
        return moneyFormat.replace(/\{\{\s*[a-z_]+\s*\}\}/, v).replace(/<[^>]+>/g, '');
      }
      function directAdd(btn){
        if(btn.dataset.busy) return;
        btn.dataset.busy = '1';
        btn.classList.add('custom-clp8n3__add--busy');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-variant-id'), 10), quantity: 1 }] })
        }).then(function(r){ if(!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
          .then(function(){
            document.dispatchEvent(new CustomEvent('candy:cart:added'));   /* cart drawer refreshes + opens */
          })
          .catch(function(){})
          .then(function(){ btn.classList.remove('custom-clp8n3__add--busy'); delete btn.dataset.busy; });
      }
      var drawer  = root.querySelector('.custom-clp8n3__drawer');
      var dBack   = drawer ? drawer.querySelector('.custom-clp8n3__drawer-back') : null;
      var dClose  = drawer ? drawer.querySelector('.custom-clp8n3__drawer-close') : null;
      var dImg    = drawer ? drawer.querySelector('.custom-clp8n3__drawer-img') : null;
      var dName   = drawer ? drawer.querySelector('.custom-clp8n3__drawer-name') : null;
      var dPrice  = drawer ? drawer.querySelector('.custom-clp8n3__drawer-price') : null;
      var dOptLbl = drawer ? drawer.querySelector('.custom-clp8n3__drawer-optlabel') : null;
      var dOpts   = drawer ? drawer.querySelector('.custom-clp8n3__drawer-opts') : null;
      var dQtyNum = drawer ? drawer.querySelector('.custom-clp8n3__qty-num') : null;
      var dAdd    = drawer ? drawer.querySelector('.custom-clp8n3__drawer-add') : null;
      var dAddT   = drawer ? drawer.querySelector('.custom-clp8n3__drawer-add-t') : null;
      var dOpen = false, dVariant = null, dQty = 1, dBaseImg = '';
      function drawerPaint(){
        /* variant image swap (user 2026-07-17) */
        if(dImg){ var vi = dVariant && dVariant.featured_image && dVariant.featured_image.src; if(vi || dBaseImg){ dImg.src = vi || dBaseImg; dImg.hidden = false; } }
        if(dQtyNum) dQtyNum.textContent = dQty;
        if(dPrice && dVariant) dPrice.textContent = money(dVariant.price * dQty);
        if(dAdd) dAdd.disabled = !dVariant || !dVariant.available;
        if(dAddT) dAddT.textContent = (dVariant && !dVariant.available) ? 'Sold out' : 'Add to basket';
        if(dOpts){
          Array.prototype.forEach.call(dOpts.querySelectorAll('.custom-clp8n3__drawer-opt'), function(b){
            b.setAttribute('aria-pressed', dVariant && String(dVariant.id) === b.getAttribute('data-id') ? 'true' : 'false');
          });
        }
      }
      function closeDrawer(){
        if(!dOpen || !drawer) return;
        dOpen = false;
        drawer.classList.remove('custom-clp8n3__drawer--on');
        drawer.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
      }
      function openDrawer(p, fallbackImg){
        if(!drawer) return;
        dOpen = true; dQty = 1;
        dVariant = null;
        for(var i = 0; i < p.variants.length; i++){ if(p.variants[i].available){ dVariant = p.variants[i]; break; } }
        if(!dVariant) dVariant = p.variants[0];
        dBaseImg = p.featured_image || fallbackImg || '';
        if(dImg){ if(dBaseImg){ dImg.src = dBaseImg; dImg.hidden = false; } else { dImg.removeAttribute('src'); dImg.hidden = true; } }
        if(dName) dName.textContent = p.title;
        if(dOpts){
          dOpts.innerHTML = '';
          if(p.variants.length > 1){
            /* /products/x.js returns options as {name,...} objects — read .name
               (a bare p.options[0] rendered "[object Object]", user 2026-07-16) */
            var optN = (p.options && p.options[0]) ? (p.options[0].name || p.options[0]) : 'Size';
            if(dOptLbl){ dOptLbl.hidden = false; dOptLbl.textContent = 'Choose your ' + String(optN).toLowerCase(); }
            function escT(t){ return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;'); }
            p.variants.forEach(function(v){
              var b = document.createElement('button');
              b.type = 'button';
              b.className = 'custom-clp8n3__drawer-opt';
              b.setAttribute('data-id', v.id);
              var vi = (v.featured_image && v.featured_image.src) || dBaseImg;
              b.innerHTML = '<span class="custom-clp8n3__drawer-opt-tick"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8.5l3.5 3.5L13 5" stroke="#ffffff" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></span>'
                + (vi ? '<img class="custom-clp8n3__drawer-opt-img" src="' + vi + '" alt="" loading="lazy"/>' : '')
                + '<span class="custom-clp8n3__drawer-opt-t">' + escT(v.title) + '</span>'
                + '<span class="custom-clp8n3__drawer-opt-p">' + money(v.price) + '</span>';
              if(!v.available) b.disabled = true;
              b.addEventListener('click', function(){ dVariant = v; drawerPaint(); });
              dOpts.appendChild(b);
            });
            if(optNav) optNav.hidden = !(p.variants.length > 2);
            dOpts.classList.toggle('custom-clp8n3__drawer-opts--slide', p.variants.length > 2);
          } else if(dOptLbl){ dOptLbl.hidden = true; }
        }
        drawerPaint();
        drawer.classList.add('custom-clp8n3__drawer--on');
        drawer.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
      }
      if(dClose) dClose.addEventListener('click', closeDrawer);
      /* slider feel for the variant row: vertical wheel scrolls it sideways,
         and it drags like the carousels (click suppressed after a drag) */
      if(dOpts){
        dOpts.addEventListener('wheel', function(e){
          if(dOpts.scrollWidth > dOpts.clientWidth && e.deltaY){ e.preventDefault(); dOpts.scrollLeft += e.deltaY; }
        }, { passive: false });
        var oDown = false, oX = 0, oL = 0, oMoved = false;
        dOpts.addEventListener('pointerdown', function(e){ oDown = true; oMoved = false; oX = e.clientX; oL = dOpts.scrollLeft; dOpts.classList.add('custom-clp8n3__drawer-opts--dragging'); });
        window.addEventListener('pointermove', function(e){
          if(!oDown) return;
          var dx = e.clientX - oX;
          if(Math.abs(dx) > 5) oMoved = true;
          if(oMoved) dOpts.scrollLeft = oL - dx;
        });
        window.addEventListener('pointerup', function(){ oDown = false; dOpts.classList.remove('custom-clp8n3__drawer-opts--dragging'); setTimeout(function(){ oMoved = false; }, 0); });
        dOpts.addEventListener('click', function(e){ if(oMoved){ e.preventDefault(); e.stopPropagation(); } }, true);
      }
      var optNav = drawer ? drawer.querySelector('.custom-clp8n3__drawer-optnav') : null;
      function optStep(dir){
        var card = dOpts ? dOpts.querySelector('.custom-clp8n3__drawer-opt') : null;
        if(!card) return;
        var gap = parseFloat(getComputedStyle(dOpts).gap) || 12;
        dOpts.scrollBy({ left: dir * (card.offsetWidth + gap), behavior: 'smooth' });
      }
      if(optNav){
        optNav.querySelector('.custom-clp8n3__drawer-optnav-b--prev').addEventListener('click', function(){ optStep(-1); });
        optNav.querySelector('.custom-clp8n3__drawer-optnav-b--next').addEventListener('click', function(){ optStep(1); });
      }
      if(dBack) dBack.addEventListener('click', closeDrawer);
      document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && dOpen) closeDrawer(); });
      Array.prototype.forEach.call(drawer ? drawer.querySelectorAll('.custom-clp8n3__qty-btn') : [], function(b){
        b.addEventListener('click', function(){
          dQty = Math.min(99, Math.max(1, dQty + parseInt(b.getAttribute('data-d'), 10)));
          drawerPaint();
        });
      });
      if(dAdd) dAdd.addEventListener('click', function(){
        if(!dVariant || dAdd.dataset.busy) return;
        dAdd.dataset.busy = '1';
        dAdd.classList.add('custom-clp8n3__drawer-add--busy');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: dVariant.id, quantity: dQty }] })
        }).then(function(r){ if(!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
          .then(function(){ closeDrawer(); document.dispatchEvent(new CustomEvent('candy:cart:added')); })
          .catch(function(){ if(dAddT) dAddT.textContent = 'Error — try again'; })
          .then(function(){ dAdd.classList.remove('custom-clp8n3__drawer-add--busy'); setTimeout(function(){ delete dAdd.dataset.busy; drawerPaint(); }, 600); });
      });
      root.addEventListener('click', function(e){
        var btn = e.target.closest ? e.target.closest('.custom-clp8n3__add[data-variant-id]') : null;
        if(!btn) return;
        e.preventDefault();
        e.stopPropagation();
        /* ONE shared quick-buy popup site-wide (user 2026-07-20) — the button now
           carries its variants from Liquid, so the sheet opens instantly. */
        if(window.candyQuickBuy){ window.candyQuickBuy(btn); return; }
        var card = btn.closest('.custom-clp8n3__card');
        var link = card ? card.querySelector('.custom-clp8n3__link') : null;
        var img  = card ? card.querySelector('.custom-clp8n3__img') : null;
        if(!drawer || !link){ directAdd(btn); return; }
        if(card.__pdata){ openDrawer(card.__pdata, img ? img.src : ''); return; }
        fetch(link.href.split('?')[0] + '.js')
          .then(function(r){ if(!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
          .then(function(p){ card.__pdata = p; openDrawer(p, img ? img.src : ''); })
          .catch(function(){ directAdd(btn); });
      }, true);

      /* ---- card video: THE differentiator (client, Ian). DESKTOP (fine pointer) = play on
             HOVER (Ian 2026-06-23: "hover video"); MOBILE = play on scroll-into-view (Ian:
             "comes alive as you scroll" — no hover on touch). Files lazy-load near the
             viewport either way so hover-play starts instantly. Pause off-screen / on leave.
             Poster-still fallback for reduced-motion / data-saver / no video. ---- */
      var saveData = navigator.connection && navigator.connection.saveData;
      var vids = root.querySelectorAll('.custom-clp8n3__vid');
      var previewsSuspended = false;
      function vidLoad(v){
        if(v.__loaded) return;
        /* the poster is data-poster until now (2026-09-24): a `poster` attribute is fetched at page load whatever preload
           says, and the clip is invisible until it plays, so a grid of 30 cards pulled ~1MB of stills nobody saw */
        if(!v.getAttribute('poster') && v.getAttribute('data-poster')) v.setAttribute('poster', v.getAttribute('data-poster'));
        Array.prototype.forEach.call(v.querySelectorAll('source[data-src]'), function(s){ s.src = s.getAttribute('data-src'); });
        v.load();
        v.__loaded = true;
        v.addEventListener('playing', function(){ v.classList.add('custom-clp8n3__vid--on'); });
      }
      function vidPlay(v){ var p = v.play(); if(p && p.catch) p.catch(function(){}); }
      /* The moment a real mouse touches the section, flag it and drop the tap buttons —
         see the .custom-clp8n3--mouse rule. once:true keeps this to a single event. */
      root.addEventListener('pointerover', function(e){
        if(e.pointerType === 'mouse') root.classList.add('custom-clp8n3--mouse');
      }, { once: true });
      /* TAP TO PLAY (hover-less devices). Autoplay-on-scroll was removed above, so a clip
         starts only on an explicit tap and the same button pauses it. Bound outside the
         reduced-motion / save-data gate below because this is user-initiated, not ambient. */
      /* ONE TAP, THEN OUT OF THE WAY (client 2026-09-08: "Play icons are back on cards ... Off.
         Video plays on tap with no icon."). The visible disc is gone; what is left is a
         transparent layer over the photo. It used to toggle play/pause, which with no icon would
         have left a phone user unable to reach the product from the picture at all - the layer
         sits over .__imglink. So the first tap starts the clip and the layer then removes itself
         from the hit test, and the next tap on the photo opens the product exactly as it did
         before (client 2026-09-05: "picture -> product"). Nothing to pause, because the clip is
         muted and loops. */
      function bindTap(btn){
        var media = btn.closest ? btn.closest('.custom-clp8n3__media') : null;
        var v = media ? media.querySelector('.custom-clp8n3__vid') : null;
        if(!v){ btn.parentNode && btn.parentNode.removeChild(btn); return; }
        btn.addEventListener('click', function(e){
          e.preventDefault(); e.stopPropagation();     /* must not follow the card link */
          previewsSuspended = false;
          vidLoad(v); vidPlay(v);
          media.classList.add('custom-clp8n3__media--playing');
          btn.style.display = 'none';
        });
      }
      Array.prototype.forEach.call(root.querySelectorAll('.custom-clp8n3__vplay'), bindTap);
      /* LOAD MORE (client 2026-09-04): cards fetched from the next server page arrive after
         init, so the pager hands each one here for the same wiring. Tap-to-play always;
         hover-play too when the gate below is open (it re-assigns this). */
      root.c4uBindCard = function(card){
        Array.prototype.forEach.call(card.querySelectorAll('.custom-clp8n3__vplay'), bindTap);
      };
      /* SEEKBAR: drag/click scrubs the clip forward/backward (fill + dot track it) */
      function bindSeek(prog, video){
        var fill = prog.querySelector('.custom-clp8n3__prog-fill');
        var dot  = prog.querySelector('.custom-clp8n3__prog-dot');
        function paint(){
          if(!video.duration) return;
          var p = video.currentTime / video.duration;
          if(fill) fill.style.transform = 'scaleX(' + p + ')';
          if(dot) dot.style.left = (p * 100) + '%';
        }
        video.addEventListener('timeupdate', paint);
        var seeking = false;
        function seekTo(clientX){
          var r = prog.getBoundingClientRect();
          var p = Math.min(1, Math.max(0, (clientX - r.left) / r.width));
          if(video.duration){ try{ video.currentTime = p * video.duration; }catch(err){} paint(); }
        }
        prog.addEventListener('pointerdown', function(e){ e.preventDefault(); e.stopPropagation(); seeking = true; seekTo(e.clientX); });
        window.addEventListener('pointermove', function(e){ if(seeking) seekTo(e.clientX); });
        window.addEventListener('pointerup', function(){ seeking = false; });
        prog.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); });
        return paint;
      }
      /* VOLUME: speaker click opens a vertical slider (line + dot); drag the dot to set
         volume; 0 = muted (icon swaps). Sound is a user gesture -> unmuted play allowed. */
      function bindVolume(mute, vol, video){
        var track = vol.querySelector('.custom-clp8n3__vol-track');
        var fill  = vol.querySelector('.custom-clp8n3__vol-fill');
        var dot   = vol.querySelector('.custom-clp8n3__vol-dot');
        var last  = 0.8;
        function paint(){
          var p = video.muted ? 0 : video.volume;
          if(fill) fill.style.height = (p * 100) + '%';
          if(dot) dot.style.bottom = (p * 100) + '%';
          mute.classList.toggle('custom-clp8n3__mute--sound', p > 0);
        }
        function setVol(p){
          p = Math.min(1, Math.max(0, p));
          if(p > 0){ video.volume = p; video.muted = false; last = p; }
          else { video.muted = true; }
          paint();
        }
        mute.addEventListener('click', function(e){
          e.preventDefault(); e.stopPropagation();
          var open = vol.classList.toggle('custom-clp8n3__vol--open');
          if(open){ setVol(video.muted ? last : (video.volume || last)); vidPlay(video); }
          else { setVol(0); }
        });
        var dragging = false;
        function fromY(clientY){
          var r = track.getBoundingClientRect();
          setVol((r.bottom - clientY) / r.height);
        }
        track.addEventListener('pointerdown', function(e){ e.preventDefault(); e.stopPropagation(); dragging = true; fromY(e.clientY); });
        window.addEventListener('pointermove', function(e){ if(dragging) fromY(e.clientY); });
        window.addEventListener('pointerup', function(){ dragging = false; });
        vol.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); });
        paint();
        return { paint: paint, set: setVol,
          reset: function(){ vol.classList.remove('custom-clp8n3__vol--open'); video.muted = true; paint(); } };
      }

      /* ---- HERO BANNER CONTROLS (client 2026-09-05: "add sound option, seek bar, full screen,
             play/pause — on hover all controls should show"). The banner clip is autoplay/muted/loop;
             this bar (sections/candy-collection.liquid, .custom-clp8n3__bctl) gives it the card's own
             pieces — bindVolume (speaker + slider), bindSeek (gradient hairline) — plus play/pause and
             a real fullscreen (Fullscreen API on the banner box, so the bar rides along; iPhone gets the
             video-only fullscreen it allows). CSS shows the bar on :hover / :focus-within; a tap on the
             footage toggles it for touch. A visitor's pause sticks — the offscreen observer above will
             not restart a banner they stopped. ---- */
      (function(){
        var banner = root.querySelector('.custom-clp8n3__banner');
        var bv = banner ? banner.querySelector('.custom-clp8n3__banner-vid') : null;
        var bar = banner ? banner.querySelector('.custom-clp8n3__bctl') : null;
        if(!banner || !bv || !bar) return;
        var play = bar.querySelector('.custom-clp8n3__bctl-play');
        var mute = bar.querySelector('.custom-clp8n3__mute');
        var vol  = bar.querySelector('.custom-clp8n3__vol');
        var prog = bar.querySelector('.custom-clp8n3__prog');
        var fs   = bar.querySelector('.custom-clp8n3__prev');
        if(prog) bindSeek(prog, bv);
        if(mute && vol) bindVolume(mute, vol, bv);
        function paintPlay(){
          banner.classList.toggle('custom-clp8n3__banner--paused', bv.paused);
          if(play) play.setAttribute('aria-label', bv.paused ? 'Play video' : 'Pause video');
        }
        bv.addEventListener('play', paintPlay);
        bv.addEventListener('pause', paintPlay);
        paintPlay();
        if(play) play.addEventListener('click', function(e){
          e.preventDefault(); e.stopPropagation();
          if(bv.paused){ bv.__userPaused = false; vidPlay(bv); }
          else { bv.__userPaused = true; bv.pause(); }
        });
        function fsEl(){ return document.fullscreenElement || document.webkitFullscreenElement || null; }
        if(fs) fs.addEventListener('click', function(e){
          e.preventDefault(); e.stopPropagation();
          if(fsEl()){ (document.exitFullscreen || document.webkitExitFullscreen).call(document); return; }
          if(banner.requestFullscreen){ var p = banner.requestFullscreen(); if(p && p.catch) p.catch(function(){}); }
          else if(banner.webkitRequestFullscreen) banner.webkitRequestFullscreen();
          else if(bv.webkitEnterFullscreen) bv.webkitEnterFullscreen();   /* iPhone Safari: video only */
        });
        function onFs(){ banner.classList.toggle('custom-clp8n3__banner--fs', fsEl() === banner); }
        document.addEventListener('fullscreenchange', onFs);
        document.addEventListener('webkitfullscreenchange', onFs);
        /* touch has no hover: a tap on the footage shows / hides the bar */
        banner.addEventListener('click', function(e){
          if(bar.contains(e.target)) return;
          banner.classList.toggle('custom-clp8n3__banner--ctl');
        });
      })();

      if(vids.length && !reduce && !saveData){
        if('IntersectionObserver' in window){
          var vio = new IntersectionObserver(function(entries){
            entries.forEach(function(en){
              var v = en.target;
              if(en.isIntersecting){
                vidLoad(v);                          /* warm the file near the viewport */
                /* No autoplay on hover-less devices (dev 2026-08-07). The clip now waits
                   for a tap on .__vplay; desktop still plays on hover, further down. */
              } else {
                v.pause();
                var pm = v.closest ? v.closest('.custom-clp8n3__media') : null;
                if(pm){
                  pm.classList.remove('custom-clp8n3__media--playing');
                  /* the tap layer stood itself down when the clip started (see bindTap); the clip
                     has just been stopped for leaving the viewport, so put it back or the card
                     could never be played a second time */
                  var pb = pm.querySelector('.custom-clp8n3__vplay');
                  if(pb) pb.style.display = '';
                }
              }
            });
          }, { rootMargin: '240px 0px' });
          Array.prototype.forEach.call(vids, function(v){ vio.observe(v); });
        }
        /* ---- FULLSCREEN THEATER: preview button FLIP-expands the clip from its card to
               centre screen (power4), plays with sound, and collapses back on close ---- */
        var theater  = root.querySelector('.custom-clp8n3__theater');
        var tBack    = theater ? theater.querySelector('.custom-clp8n3__theater-back') : null;
        var tBox     = theater ? theater.querySelector('.custom-clp8n3__theater-box') : null;
        var tVid     = theater ? theater.querySelector('.custom-clp8n3__theater-vid') : null;
        var tClose   = theater ? theater.querySelector('.custom-clp8n3__theater-close') : null;
        var tBar     = theater ? theater.querySelector('.custom-clp8n3__theater-bar') : null;
        var tName    = theater ? theater.querySelector('.custom-clp8n3__theater-name') : null;
        var tMute    = theater ? theater.querySelector('.custom-clp8n3__mute--theater') : null;
        var tVol     = theater ? theater.querySelector('.custom-clp8n3__vol--theater') : null;
        var tProg    = theater ? theater.querySelector('.custom-clp8n3__prog--theater') : null;
        var tOpen = false, tSrcVid = null, tSrcMedia = null, tSrcCard = null, tVolCtl = null;
        if(theater && tVid){
          if(tProg) bindSeek(tProg, tVid);
          if(tMute && tVol) tVolCtl = bindVolume(tMute, tVol, tVid);
          var tTarget = function(){
            var s = Math.min(window.innerWidth * 0.86, window.innerHeight * 0.8);
            return { left: (window.innerWidth - s) / 2, top: (window.innerHeight - s) / 2, width: s, height: s };
          };
          var openTheater = function(card, v, media){
            if(tOpen) return;
            tOpen = true; tSrcVid = v; tSrcMedia = media; tSrcCard = card;
            tVid.innerHTML = '';
            Array.prototype.forEach.call(v.querySelectorAll('source'), function(s){
              var n = document.createElement('source');
              n.src = s.src || s.getAttribute('data-src');
              n.type = s.type;
              tVid.appendChild(n);
            });
            tVid.load();
            tVid.addEventListener('loadedmetadata', function once(){ try{ tVid.currentTime = v.currentTime; }catch(err){} tVid.removeEventListener('loadedmetadata', once); });
            if(tName){ var nm = card.querySelector('.custom-clp8n3__name'); tName.textContent = nm ? nm.textContent : ''; }
            v.pause();
            theater.classList.add('custom-clp8n3__theater--on');
            theater.setAttribute('aria-hidden', 'false');
            document.documentElement.style.overflow = 'hidden';
            tVid.volume = 0.8; tVid.muted = false;
            if(tVolCtl) tVolCtl.paint();
            var pl = tVid.play();
            if(pl && pl.catch) pl.catch(function(){
              // An interrupted play on navigation is not an autoplay rejection.
              if(!tOpen || document.hidden) return;
              tVid.muted = true;
              if(tVolCtl) tVolCtl.paint();
              tVid.play().catch(function(){});
            });
            var from = media.getBoundingClientRect(), to = tTarget();
            /* the GSAP zoom-from-the-card open was removed 2026-07-21 — the panel
               is placed straight onto its final box */
            tBack.style.opacity = 1; tBar.style.opacity = 1;
            tBox.style.left = (to.left / window.innerWidth * 100) + 'vw'; tBox.style.top = (to.top / window.innerWidth * 100) + 'vw';
            tBox.style.width = (to.width / window.innerWidth * 100) + 'vw'; tBox.style.height = (to.height / window.innerWidth * 100) + 'vw';
          };
          var closeTheater = function(resumePreview){
            if(!tOpen) return;
            tOpen = false;
            var done = function(){
              theater.classList.remove('custom-clp8n3__theater--on');
              theater.setAttribute('aria-hidden', 'true');
              document.documentElement.style.overflow = '';
              tVid.pause();
              if(tVolCtl) tVolCtl.reset();
              if(tSrcVid){
                try{ tSrcVid.currentTime = tVid.currentTime; }catch(err){}
                if(resumePreview !== false && tSrcCard && tSrcCard.matches(':hover')) vidPlay(tSrcVid);
              }
            };
            var to = tSrcMedia ? tSrcMedia.getBoundingClientRect() : null;
            done();
          };
          if(tClose) tClose.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); closeTheater(); });
          if(tBack) tBack.addEventListener('click', closeTheater);
          document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && tOpen) closeTheater(); });
        }

        /* HOVER-PLAY IS BOUND UNCONDITIONALLY (client 2026-08-07: "on desktop is playing by
           click, it should play by hover"). This used to sit behind a media-query gate, but
           every form of that question — (hover: hover), (pointer: fine), even (any-hover) —
           kept answering "touch" on a touchscreen laptop, so the trackpad got nothing and
           the only way to start a clip was the tap button. The gate was never needed:
           mouseenter does not fire on a real touch device, so binding it there costs
           nothing. Mouse => hover-play; touch => the button, which is still the only
           control that draws under (any-hover: none). */
        {
          function bindHover(v){
            var card  = v.closest('.custom-clp8n3__card');
            var media = v.closest('.custom-clp8n3__media');
            if(!card || !media) return;
            var mute = media.querySelector('.custom-clp8n3__mute');
            var vol  = media.querySelector('.custom-clp8n3__vol');
            var prog = media.querySelector('.custom-clp8n3__prog');
            var prev = media.querySelector('.custom-clp8n3__prev');
            var volCtl = (mute && vol) ? bindVolume(mute, vol, v) : null;
            var progPaint = prog ? bindSeek(prog, v) : null;
            v.c4uResetPreviewControls = function(){
              if(volCtl) volCtl.reset();
              if(progPaint) progPaint();
            };
            if(prev) prev.addEventListener('click', function(e){
              e.preventDefault(); e.stopPropagation();
              vidLoad(v);
              openTheater && openTheater(card, v, media);
            });
            card.addEventListener('mouseenter', function(){
              if(previewsSuspended) return;
              vidLoad(v);
              vidPlay(v);
              media.classList.add('custom-clp8n3__media--live');
            });
            card.addEventListener('mouseleave', function(){
              if(tOpen) return;   /* theater owns the clip right now */
              /* fade back to the photo, rewind, hide controls, close + re-mute the volume
                 slider so the next hover never blasts sound unexpectedly */
              v.pause();
              v.classList.remove('custom-clp8n3__vid--on');
              media.classList.remove('custom-clp8n3__media--live');
              try{ v.currentTime = 0; }catch(err){}
              if(volCtl) volCtl.reset();
              if(progPaint) progPaint();
            });
          }
          Array.prototype.forEach.call(vids, bindHover);
          root.c4uBindCard = function(card){
            Array.prototype.forEach.call(card.querySelectorAll('.custom-clp8n3__vid'), function(v){
              if(vio) vio.observe(v);
              bindHover(v);
            });
            Array.prototype.forEach.call(card.querySelectorAll('.custom-clp8n3__vplay'), bindTap);
          };
        }
      }

      /* Product previews belong to the current interaction. A cached collection must
         return to still photographs, not resume every previously tapped clip. */
      function resetCardVideo(v){
        v.pause();
        v.muted = true;
        v.classList.remove('custom-clp8n3__vid--on');
        try { v.currentTime = 0; } catch(err) {}
        if(v.c4uResetPreviewControls) v.c4uResetPreviewControls();
        var media = v.closest('.custom-clp8n3__media');
        if(!media) return;
        media.classList.remove('custom-clp8n3__media--playing', 'custom-clp8n3__media--live');
        var tap = media.querySelector('.custom-clp8n3__vplay');
        if(tap) tap.style.display = '';
      }
      function stopProductPreviews(){
        previewsSuspended = true;
        if(typeof closeTheater === 'function') closeTheater(false);
        root.querySelectorAll('.custom-clp8n3__vid, .custom-clp8n3__theater-vid').forEach(resetCardVideo);
      }
      // Removing the theater or restoring a cached page can synthesize mouseenter
      // beneath a stationary cursor. Resume hover only after a real pointer move.
      root.addEventListener('pointermove', function(e){
        if(!previewsSuspended || e.pointerType !== 'mouse' || document.hidden) return;
        previewsSuspended = false;
        if(reduce || saveData) return;
        var card = e.target.closest('.custom-clp8n3__card');
        var v = card && card.querySelector('.custom-clp8n3__vid');
        if(!v) return;
        vidLoad(v); vidPlay(v);
        var media = v.closest('.custom-clp8n3__media');
        if(media) media.classList.add('custom-clp8n3__media--live');
      });
      root.addEventListener('play', function(e){
        if(!e.target.matches('.custom-clp8n3__vid, .custom-clp8n3__theater-vid')) return;
        if(document.hidden){ resetCardVideo(e.target); return; }
        root.querySelectorAll('.custom-clp8n3__vid, .custom-clp8n3__theater-vid').forEach(function(v){
          if(v !== e.target && !v.paused) resetCardVideo(v);
        });
      }, true);
      window.addEventListener('pagehide', stopProductPreviews);
      window.addEventListener('pageshow', stopProductPreviews);
      document.addEventListener('visibilitychange', function(){
        if(document.hidden) stopProductPreviews();
      });

      /* the GSAP choreography (hero title wipe, chip hinge, batched card rise, shine
         sweep, magnetic buttons, pagination rise, glow parallax) was removed
         2026-07-21 (user). The cards were the only elements it hid up-front, so they
         now render straight from the resting CSS. */
    })();

  (function () {
  /* ---------------------------------------------------------------------
     CARD FLIP (user 2026-09-04): the taste bars moved off the info block and
     onto the back of the tile; the eye turns it over.

     Delegated, so cards that arrive later (filtering, pagination) work with no
     re-binding. Three things the click has to do beyond toggling a class:
       - stopPropagation, because .__link is an overlay anchor across the whole
         card and would otherwise navigate to the product,
       - pause the clip, since a card face-down must not keep playing audio or
         burning frames behind the panel,
       - move aria-hidden between the faces so a screen reader is never offered
         the side that is facing away.
     Only one card is ever open: flipping a second closes the first, which keeps
     a grid of turned-over tiles from becoming unreadable.
     --------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var eye = e.target.closest && e.target.closest('.custom-clp8n3__eye');
    if (!eye) return;
    e.preventDefault();
    e.stopPropagation();

    var media = eye.closest('.custom-clp8n3__media');
    if (!media) return;
    var open = !media.classList.contains('custom-clp8n3__media--flip');

    document.querySelectorAll('.custom-clp8n3__media--flip').forEach(function (m) {
      if (m === media) return;
      m.classList.remove('custom-clp8n3__media--flip');
      var b = m.querySelector('.custom-clp8n3__eye');
      if (b) { b.setAttribute('aria-pressed', 'false'); }
      setFaces(m, false);
    });

    media.classList.toggle('custom-clp8n3__media--flip', open);
    eye.setAttribute('aria-pressed', open ? 'true' : 'false');
    setFaces(media, open);

    if (open) {
      var v = media.querySelector('.custom-clp8n3__vid');
      if (v && !v.paused) { try { v.pause(); } catch (err) {} }
    }
  }, true);

  function setFaces(media, open) {
    var face = media.querySelector('.custom-clp8n3__face');
    var back = media.querySelector('.custom-clp8n3__back');
    if (face) { face.setAttribute('aria-hidden', open ? 'true' : 'false'); }
    if (back) { back.setAttribute('aria-hidden', open ? 'false' : 'true'); }
    /* the hidden face must leave the tab order too, or Tab walks into a turned-away panel */
    var hide = open ? face : back;
    var show = open ? back : face;
    if (hide) { hide.querySelectorAll('a,button,video,[tabindex]').forEach(function (el) { el.setAttribute('tabindex', '-1'); }); }
    if (show) { show.querySelectorAll('a,button,video').forEach(function (el) { el.removeAttribute('tabindex'); }); }
  }

  /* Esc closes whatever is turned over */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.custom-clp8n3__media--flip').forEach(function (m) {
      m.classList.remove('custom-clp8n3__media--flip');
      var b = m.querySelector('.custom-clp8n3__eye');
      if (b) { b.setAttribute('aria-pressed', 'false'); b.focus(); }
      setFaces(m, false);
    });
  });

  /* ---------------------------------------------------------------------
     LOAD MORE (client 2026-09-04): "Replace the numbered pages with a Load
     More button showing a count, for example showing 24 of 29."

     Each press asks for 24 more products, then the cut is ROUNDED TO A WHOLE
     ROW, measured from the grid the browser actually laid out (offsetTop
     groups, widths in columns) rather than assumed - so column count, the
     two-column feature cards, the promo tiles and grid-auto-flow: dense are
     all accounted for. A last row holding a single product hands it to the
     next press; a last row holding two or more is topped up to full. The line
     above the button reads "Showing 26 of 29".

     A collection bigger than one server page (Solo Candy) keeps working: when
     the local cards run out the button fetches Shopify's next page, appends its
     cards and carries on. Fetched cards get their video wiring from
     root.c4uBindCard (see the video block above). If the fetch fails the button
     falls back to a plain navigation to that page - never a dead end.
     --------------------------------------------------------------------- */
  (function(){
    var grid = document.querySelector('.custom-clp8n3__grid');
    if(!grid) return;
    var root = grid.closest('.custom-clp8n3') || document;
    var PG = 'custom-clp8n3__card--pg', HIDE = 'custom-clp8n3__card--hide', STEP = 24;
    var IN = 'custom-clp8n3__in';   /* the entrance animation for cards a press reveals */
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var animateNext = false;        /* set by the button only: initial paint, filters and resizes never animate */

    /* Shopify's own pager, present only when the collection spans server pages.
       Hidden, not removed: crawlers and no-JS visitors still get the links. */
    var serverNav = root.querySelector('.custom-clp8n3__pag');
    var nextA = serverNav ? serverNav.querySelector('a[aria-label="Next page"]') : null;
    var nextUrl = nextA ? nextA.href : null;
    if(serverNav) serverNav.hidden = true;

    /* the unfiltered total, read once before any filter touches the count */
    var countEl = root.querySelector('.custom-clp8n3__count-num');
    var total = grid.hasAttribute('data-grid-total') ? parseInt(grid.getAttribute('data-grid-total'), 10) : (countEl ? (parseInt(countEl.textContent, 10) || 0) : 0);

    var ui = document.createElement('div');
    ui.className = 'custom-clp8n3__more';
    ui.hidden = true;
    ui.innerHTML = '<p class="custom-clp8n3__more-count" aria-live="polite">Showing <b class="custom-clp8n3__more-n">0</b> of <b class="custom-clp8n3__more-t">0</b></p>' +
                   '<button type="button" class="custom-clp8n3__more-btn"><span class="custom-clp8n3__more-btn-text">Load more</span></button>';
    grid.insertAdjacentElement('afterend', ui);
    var nEl = ui.querySelector('.custom-clp8n3__more-n');
    var tEl = ui.querySelector('.custom-clp8n3__more-t');
    var btn = ui.querySelector('.custom-clp8n3__more-btn');

    /* how many products are open survives a trip into a product and back (per tab, per URL) */
    var key = 'c4u-more:' + location.pathname + location.search;
    /* GRID RHYTHM (client 2026-09-14): the section says how many cards to open before the button
       (data-first: 32 plus any feature cards placed inside them), so Load More comes after the second
       feature tile. Pages without it (search) keep STEP. */
    var FIRST = parseInt(grid.getAttribute('data-first'), 10) || STEP;
    var target = FIRST, shownNow = 0, loading = false, lastCols = 0;
    /* the open count comes back ONLY on back/forward from a product page. A reload or a
       fresh visit always starts at the first step (user 2026-09-04: a refresh must not
       land on "29 of 29"). */
    try {
      var navEntry = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
      if(navEntry && navEntry.type === 'back_forward'){
        target = Math.max(FIRST, parseInt(sessionStorage.getItem(key), 10) || FIRST);
      } else {
        sessionStorage.removeItem(key);
      }
    } catch(err){}

    function isCard(el){ return el.classList.contains('custom-clp8n3__card'); }
    function isTile(el){ return el.classList.contains('custom-clp8n3__tile'); }
    function items(){
      /* cards and promo tiles in grid order, minus whatever the filters hid */
      return Array.prototype.filter.call(grid.children, function(el){
        return (isCard(el) || isTile(el)) && !el.hidden && !el.classList.contains(HIDE);
      });
    }
    function filtering(){ return !!grid.querySelector('.custom-clp8n3__card.' + HIDE); }

    /* show the first n products (a promo tile rides along with the card before it).
       With animateNext on, anything that was hidden and is now shown rises in, staggered
       in grid order; the class and delay clean themselves up when the animation ends. */
    function reveal(n){
      var shown = 0, all = 0, cut = false, lastShown = true, more = false, fresh = 0;
      items().forEach(function(el){
        var show;
        if(isTile(el)){
          /* an end tile closes the grid and is always on; any other tile rides along
             with the card before it */
          show = el.hasAttribute('data-tile-end') ? true : lastShown;
        } else {
          all++;
          show = !cut && shown < n;
          if(show){ shown++; } else { cut = true; more = true; }
          lastShown = show;
        }
        var was = el.classList.contains(PG);
        el.classList.toggle(PG, !show);
        if(show && was && animateNext && !reduce) enter(el, fresh++);
      });
      return { shown: shown, all: all, more: more };
    }
    function enter(el, i){
      el.style.animationDelay = (Math.min(i, 20) * 45) + 'ms';
      el.classList.add(IN);
      el.addEventListener('animationend', function done(){
        el.classList.remove(IN);
        el.style.animationDelay = '';
      }, { once: true });
    }
    /* the count rolls from the old number to the new one and gives a small bump */
    function roll(from, to){
      if(reduce || from === to || !window.requestAnimationFrame){ nEl.textContent = to; return; }
      var t0 = performance.now(), dur = 560;
      nEl.classList.remove('custom-clp8n3__more-n--bump');
      void nEl.offsetWidth;
      nEl.classList.add('custom-clp8n3__more-n--bump');
      (function step(now){
        var p = Math.min(1, (now - t0) / dur);
        p = 1 - Math.pow(1 - p, 3);
        nEl.textContent = Math.round(from + (to - from) * p);
        if(p < 1) requestAnimationFrame(step);
      })(t0);
      /* rAF is paused in a background tab: whatever happens, the final number lands */
      setTimeout(function(){ nEl.textContent = to; }, dur + 60);
    }

    /* the grid as laid out right now: column count and track width, from the browser */
    function tracks(){
      var cs = getComputedStyle(grid);
      var list = (cs.gridTemplateColumns || '').trim().split(/\s+/).filter(Boolean);
      var w = parseFloat(list[0]) || grid.clientWidth;
      var gap = parseFloat(cs.columnGap) || 0;
      return { n: Math.max(1, list.length), w: w, gap: gap };
    }
    /* what sits on the LAST visible row: products on it and the columns still free */
    function lastRow(){
      var tr = tracks();
      var vis = items().filter(function(el){ return !el.classList.contains(PG) && !el.hasAttribute('data-tile-end'); });
      var top = -1;
      vis.forEach(function(el){ if(el.offsetTop > top) top = el.offsetTop; });
      var cards = 0, used = 0;
      vis.forEach(function(el){
        if(Math.abs(el.offsetTop - top) > 2) return;
        var span = Math.max(1, Math.round((el.offsetWidth + tr.gap) / (tr.w + tr.gap)));
        used += Math.min(span, tr.n);
        if(isCard(el)) cards++;
      });
      return { cards: cards, free: Math.max(0, tr.n - used), cols: tr.n };
    }

    function layout(){
      var r = reveal(target);
      /* round the cut to a whole row. Bounded: each pass either fills or empties the
         last row, and a pass that cannot move stops the loop. */
      for(var pass = 0; pass < 4 && r.more; pass++){
        var lr = lastRow();
        if(lr.free === 0 || lr.cards === 0) break;
        var want = lr.cards === 1 ? r.shown - 1 : r.shown + lr.free;
        if(want < 1 || want === target) break;
        target = want;
        r = reveal(target);
      }
      target = Math.max(r.shown, 1);
      var prev = shownNow;
      shownNow = r.shown;
      lastCols = tracks().n;
      /* unfiltered on a multi-page collection the total is the whole collection;
         filtering only ever covers the cards in the browser, so then it is those */
      var denom = (!filtering() && nextUrl) ? Math.max(total, r.all) : r.all;
      if(animateNext) roll(prev, r.shown); else nEl.textContent = r.shown;
      animateNext = false;
      tEl.textContent = denom;
      btn.hidden = !(r.more || (!filtering() && !!nextUrl));
      ui.hidden = r.all === 0;
      try { sessionStorage.setItem(key, String(r.shown)); } catch(err){}
    }

    function readyMedia(card){
      /* same skeleton hand-off the init code gives the first page's cards */
      Array.prototype.forEach.call(card.querySelectorAll('.custom-clp8n3__media'), function(media){
        var im = media.querySelector('.custom-clp8n3__img');
        var done = function(){ media.classList.add('custom-clp8n3__media--ready'); };
        if(!im || im.complete){ done(); return; }
        im.addEventListener('load', done, { once: true });
        im.addEventListener('error', done, { once: true });
      });
    }

    /* ONE server page, fetched and appended hidden above the closing tile. Used by the
       Load more button and by c4uLoadAllPages below. */
    /* cards on a full server page, read off page 1 before anything is appended */
    var pageFull = grid ? Array.prototype.filter.call(grid.children, isCard).length : 0;
    function appendPage(url){
      return fetch(url, { credentials: 'same-origin' })
        .then(function(res){ if(!res.ok) throw new Error('HTTP ' + res.status); return res.text(); })
        .then(function(html){
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var g2 = doc.querySelector('.custom-clp8n3__grid');
          var cards = g2 ? Array.prototype.filter.call(g2.children, isCard) : [];
          if(!cards.length) throw new Error('no cards');
          var n2 = doc.querySelector('.custom-clp8n3__pag a[aria-label="Next page"]');
          nextUrl = n2 ? new URL(n2.getAttribute('href'), url).href : null;
          /* no Next link but a full page: the cached count undercounts (see c4uLoadAllPages),
             so the next page is asked for anyway; appendPage throws on an empty one */
          pageFull = Math.max(pageFull, cards.length);
          if(!nextUrl && cards.length >= pageFull && /[?&]page=\d+/.test(url)){
            nextUrl = url.replace(/([?&]page=)(\d+)/, function(m, a, d){ return a + (parseInt(d, 10) + 1); });
          }
          /* never append a product twice, whatever the server sends */
          var have = {};
          Array.prototype.forEach.call(grid.querySelectorAll('.custom-clp8n3__link'), function(a){ have[a.getAttribute('href').split('?')[0]] = true; });
          var endTile = grid.querySelector('[data-tile-end]');   /* fetched cards go ABOVE the closing tile */
          var added = 0;
          cards.forEach(function(c){
            var a = c.querySelector('.custom-clp8n3__link');
            if(a && have[a.getAttribute('href').split('?')[0]]) return;
            c.__c4uMore = true;                  /* the observer below must not read this as a re-sort */
            c.classList.add(PG);                 /* arrives hidden, so the reveal can animate it in */
            grid.insertBefore(c, endTile);
            readyMedia(c);
            if(root.c4uBindCard) root.c4uBindCard(c);
            added++;
          });
          return added;
        });
    }

    /* FILTERS ACROSS EVERY SERVER PAGE (client 2026-09-11: "There's only three sugar-free").
       The chips filter the cards that are in the browser, so on a collection split over server
       pages they only ever saw the first one: Sugar-Free on the 442 product catalogue matched the
       three that sit on page 1 while the store holds twelve.

       The first chip that goes on calls this. Every remaining page is requested AT ONCE, with
       &section_id= so the reply carries this section alone (317KB rather than 618KB a page here),
       and the cards land in ONE pass with the filter run once at the end - the products appear
       together, not one page at a time (user 2026-09-12: "it should instant render all"). It runs
       on the first chip only, never on page load, so an ordinary visit fetches nothing, and a
       collection that fits on one page never calls it at all. */
    var allLoaded = !nextUrl, pending = null;
    function restPages(){
      /* the hidden server pager carries the page links; the highest is the last page */
      var last = 1, href = null;
      if(serverNav){
        Array.prototype.forEach.call(serverNav.querySelectorAll('a[href]'), function(a){
          var m = a.getAttribute('href').match(/[?&]page=(\d+)/);
          if(m && parseInt(m[1], 10) >= last){ last = parseInt(m[1], 10); href = a.getAttribute('href'); }
        });
      }
      var out = [];
      if(href){ for(var n = 2; n <= last; n++) out.push(href.replace(/([?&]page=)\d+/, '$1' + n)); }
      return out;
    }
    function grab(url, sid){
      /* the section alone when the theme answers that way, the whole page if it does not */
      var pick = function(html){
        var doc = new DOMParser().parseFromString(html || '', 'text/html');
        return doc.querySelector('.custom-clp8n3__grid') ? doc : null;
      };
      var get = function(u){ return fetch(u, { credentials: 'same-origin' }).then(function(r){ return r.ok ? r.text() : ''; }).then(pick); };
      if(!sid) return get(url).catch(function(){ return null; });
      return get(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sid))
        .then(function(doc){ return doc || get(url); })
        .catch(function(){ return null; });
    }
    root.c4uMorePages = function(){ return !allLoaded && restPages().length > 0; };
    root.c4uLoadAllPages = function(done){
      var ring = function(v){ if(typeof done === 'function') done(); return v; };
      if(allLoaded) return Promise.resolve(ring(false));
      if(pending) return pending.then(ring);
      var urls = restPages();
      if(!urls.length){ allLoaded = true; return Promise.resolve(ring(false)); }
      var sec = root.closest ? root.closest('.shopify-section') : null;
      var sid = sec && sec.id ? sec.id.replace('shopify-section-', '') : null;
      btn.disabled = true;
      btn.classList.add('custom-clp8n3__more-btn--busy');
      /* THE PAGER CAN UNDERCOUNT (2026-09-13, Retro): its links come from products_count, which
         Shopify caches, so a collection that has just grown still links to page 4 while page 5
         holds products. After the linked pages land, keep asking for the next page while the
         last one came back full; an empty page ends it. */
      var cardsIn = function(doc){
        var g2 = doc && doc.querySelector('.custom-clp8n3__grid');
        return g2 ? Array.prototype.filter.call(g2.children, isCard).length : 0;
      };
      var probe = function(docs, n){
        var last = cardsIn(docs[docs.length - 1]);
        var full = Math.max.apply(null, docs.map(cardsIn).concat([pageFull]));
        if(!last || last < full || n > urls.length + 21) return docs;
        return grab(urls[urls.length - 1].replace(/([?&]page=)\d+/, '$1' + n), sid).then(function(doc){
          if(!cardsIn(doc)) return docs;
          docs.push(doc);
          return probe(docs, n + 1);
        });
      };
      pending = Promise.all(urls.map(function(u){ return grab(u, sid); }))
        .then(function(docs){ return probe(docs, urls.length + 2); })
        .then(function(docs){
        var endTile = grid.querySelector('[data-tile-end]');
        var have = {};
        Array.prototype.forEach.call(grid.querySelectorAll('.custom-clp8n3__link'), function(a){ have[a.getAttribute('href').split('?')[0]] = true; });
        var frag = document.createDocumentFragment();
        docs.forEach(function(doc){
          if(!doc) return;
          var g2 = doc.querySelector('.custom-clp8n3__grid');
          if(!g2) return;
          Array.prototype.filter.call(g2.children, isCard).forEach(function(c){
            var a = c.querySelector('.custom-clp8n3__link');
            if(a){
              if(have[a.getAttribute('href').split('?')[0]]) return;      /* never the same product twice */
              have[a.getAttribute('href').split('?')[0]] = true;
            }
            c.__c4uMore = true;                             /* the observer must not read this as a re-sort */
            c.classList.add(PG);                            /* arrives hidden: no layout, no image decode */
            frag.appendChild(c);
          });
        });
        var added = Array.prototype.slice.call(frag.children);
        grid.insertBefore(frag, endTile);                   /* ONE insert, one render */
        added.forEach(function(c){ readyMedia(c); if(root.c4uBindCard) root.c4uBindCard(c); });
        allLoaded = true;
        nextUrl = null;
        pending = null;
        btn.disabled = false;
        btn.classList.remove('custom-clp8n3__more-btn--busy');
        if(typeof done === 'function') done();              /* the filter runs once, over the finished grid */
        layout();
        return true;
      }).catch(function(){
        pending = null;
        btn.disabled = false;
        btn.classList.remove('custom-clp8n3__more-btn--busy');
        return ring(false);      /* the filter still runs, on whatever did arrive */
      });
      return pending;
    };

    btn.addEventListener('click', function(){
      if(loading) return;
      /* enough local cards for a whole step, or nothing left to fetch: just reveal.
         Otherwise fetch first, so a press never reveals a lonely one or two cards. */
      var local = grid.querySelectorAll('.custom-clp8n3__card.' + PG + ':not(.' + HIDE + '):not([hidden])').length;
      if(local >= STEP || !nextUrl){
        if(local > 0){ animateNext = true; target = shownNow + STEP; layout(); }
        return;
      }
      loading = true;
      btn.disabled = true;
      btn.classList.add('custom-clp8n3__more-btn--busy');
      var url = nextUrl;
      appendPage(url)
        .then(function(){
          animateNext = true;
          target = shownNow + STEP;
          layout();
        })
        .catch(function(){
          /* could not fetch: fall back to a plain navigation, never a dead button */
          window.location.href = url;
        })
        .then(function(){
          loading = false;
          btn.disabled = false;
          btn.classList.remove('custom-clp8n3__more-btn--busy');
        });
    });

    /* the filters flip --hide on the cards and the taste sort re-appends them: both go
       back to the first step. Cards this pager appended itself are ignored, and so is
       the paging class it writes, so it never feeds on its own work. */
    new MutationObserver(function(recs){
      var hit = recs.some(function(r){
        if(r.type === 'childList'){
          if(r.target !== grid) return false;
          if(r.removedNodes.length) return true;
          return Array.prototype.some.call(r.addedNodes, function(n){ return !n.__c4uMore; });
        }
        if(r.target.parentNode !== grid) return false;
        if(r.attributeName === 'hidden') return r.target.hasAttribute('data-favourite');
        return ((r.oldValue || '').indexOf(HIDE) > -1) !== r.target.classList.contains(HIDE);
      });
      if(hit){ target = FIRST; layout(); }
    }).observe(grid, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden'], attributeOldValue: true });

    /* a breakpoint change re-cuts the rows; the count of open products is kept */
    var rt;
    window.addEventListener('resize', function(){
      clearTimeout(rt);
      rt = setTimeout(function(){ if(tracks().n !== lastCols){ target = shownNow; layout(); } }, 120);
    });
    layout();
  })();

  })();
